import React from 'react';
import { useSelector } from 'react-redux';

function LoginIframe() {
  const { SAMLResponse } = useSelector(store => store.iframe);
  const { loginIframeDebug } = useSelector(store => store.theme);
  const { loginAttempt } = useSelector(store => store.telephony);

  return (
    <div className="row pe-2" style={{ display: loginIframeDebug ? 'block' : 'none' }}>
      { (loginAttempt && SAMLResponse) ? (
        <iframe
          title="connect-login-iframe"
          id="connect-login-iframe"
          src="/connect-sso"
          style={{ width: '100%', height: '600px' }}
          onLoad={(e) => console.log('******* LoginIframe event: ', e)}
        />
      ) : null}
    </div>
  );
}

export default LoginIframe;
